import useValidation from "../../hooks/useValidation"
import { useEffect, useState } from "react"
import FieldDescription from "../tools/FieldDescription"
import { format, parse, isValid } from "date-fns";

import "react-datepicker/dist/react-datepicker.css";
import { registrationReferenceValidationSchema } from "../../utils/validation/registrationReferenceValidationSchema"
import { MariageContractType } from "../../static/types/commonTypes/mariageContractType";

type mariageContractProps = {
    mariageContract: MariageContractType,
    changeMariageContract: ( mariageContract: Partial<MariageContractType> ) => void,
}

export default function MariageContract({
    mariageContract,
    changeMariageContract,
}: mariageContractProps ) {

    const [ editDate, setActeDate ] = useState<string>("");

    useEffect(() => {
        if (mariageContract.editDate) {
            const parsedDate = parse(mariageContract.editDate, "dd/MM/yyyy", new Date());
            setActeDate(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
        }
    }, [mariageContract]);

    const handleActeDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());
        const formattedDate = isValid(parsedDate) ? format(parsedDate, "dd/MM/yyyy") : "";

        setActeDate(inputDate);
        changeMariageContract({ editDate: formattedDate });
    };

    const openDatePicker = (id: string) => {
        const input = document.getElementById(id) as HTMLInputElement;
        input?.showPicker();
    };

    return (
        <>
            <div className="mb-3 row">

                <label htmlFor="editor" className="col-sm-2 col-form-label"> Rédigé par Maître </label>

                <div className="col-sm-10 mb-3">
                    <input
                        className="form-control"
                        type="text"
                        id="editor"
                        value={mariageContract.editor || ""}
                        onChange={event => changeMariageContract({ editor: event.target.value })}
                    />
                </div>

            </div>
            
            <div className="mb-3 row">

                <label htmlFor="editPlace" className="col-sm-2 col-form-label"> Rédigé à </label>

                <div className="col-sm-10 mb-3">
                    <input
                        className="form-control"
                        type="text"
                        id="editPlace"
                        value={mariageContract.editPlace || ""}
                        onChange={event => changeMariageContract({ editPlace: event.target.value })}
                    />
                </div>

            </div>

            <div className="mb-3 row">

                <label htmlFor="editDate" className="col-sm-2 col-form-label"> En date du </label>

                <div className="col-sm-10 mb-3">
                    <input
                        className='form-control'
                        type="date"
                        id="editDate"
                        value={editDate}
                        onChange={handleActeDateChange}
                        onClick={() => openDatePicker("editDate")}
                        placeholder="JJ/MM/AAAA"
                    />
                </div>
            </div>

        </>
    );
}
